import ContextOption from './ContextOption';

export default class IncludeBraces extends ContextOption {

    static default = true;

    static label = 'Include {}';

    output() {
        return `<li>{</li>${this.decorator.output()}<li>}</li>`;
    }

}